<template>
  <v-dialog
    v-model="visible"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card class="d-flex flex-column black full-height">
      <!-- Toolbar -->
      <v-toolbar flat color="black" dark style="flex: 0">
        <!-- Close icon button -->
        <!-- <v-btn icon @click="close">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn> -->

        <!-- File name -->
        <v-toolbar-title class="truncate-text white--text" :title="fileName">
          {{ fileName }}
        </v-toolbar-title>

        <v-spacer />

        <!-- Close text button -->
        <v-btn text @click="close" class="white--text">
          Close
        </v-btn>

        <!-- Fullscreen toggle button -->
        <!-- <v-btn icon @click="toggleFullscreen" color="primary">
          <v-icon
            :path="isFullscreen ? icons.mdiFullscreenExit : icons.mdiFullscreen"
            color="white"
          />
        </v-btn> -->
      </v-toolbar>

      <!-- Content area -->
      <v-card-text
        class="d-flex flex-grow-1 justify-center align-center pa-0 overflow-y-hidden"
      >
        <template v-if="isImage(src)">
          <img
            :src="src"
            alt="preview"
            class="max-height-full max-width-full"
            style="object-fit: contain;"
          />
        </template>

        <template v-else-if="isVideo(src)">
          <video
            ref="videoPlayer"
            :src="src"
            controls
            autoplay
            class="max-height-full max-width-full"
            style="object-fit: contain;"
          />
        </template>

        <template v-else>
          <div class="white--text">Unsupported file type</div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiFullscreen, mdiFullscreenExit, mdiDrag } from '@mdi/js'
export default {
  name: 'ResourceViewer',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isFullscreen: false,
      icons: {
        fullscreen: mdiFullscreen,
        fullscreenExit: mdiFullscreenExit,
        drag: mdiDrag,
      },
    }
  },

  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val) // Vuetify 2.x uses "input" for v-model binding
      },
    },
  },

  methods: {
    pauseVideo() {
      const videoRef = this.$refs.videoPlayer
      videoRef && videoRef.pause()
    },
    close() {
      this.visible = false
    },

    isImage(url) {
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(url)
    },

    isVideo(url) {
      return /\.(mp4|webm|ogg|mov)$/i.test(url)
    },

    toggleFullscreen() {
      const el = this.$el
      if (!this.isFullscreen) {
        if (el.requestFullscreen) {
          el.requestFullscreen()
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen()
        }
        this.isFullscreen = true
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
        this.isFullscreen = false
      }
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        const videoRef = this.$refs.videoPlayer
        videoRef && videoRef.pause()
      }
    },
  },
}
</script>

<style scoped>
.truncate-text {
  max-width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.full-height {
  height: 100%;
}

.max-width-full {
  max-width: 100%;
}

.max-height-full {
  max-height: 100%;
}
</style>
